export const PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

const DATE_INITIAL_VALUE = '';

export const START_DATE = 'startDate';
export const DUE_DATE = 'dueDate';
export const START_DUE_DATE_RANGE = 'startDueDateRange';

export const ASSIGNED_USER_ID = 'assignedUserId';
export const ASSIGNED_USER_NAME = 'assignedUserName';
export const ASSIGN_TO = 'assignTo';
export const TEAM = 'team';

export const TASK_ASSIGN_TO_FIELDS = {
  ASSIGN_TO,
  TEAM: 'team',
  USER: 'user',
};

export const ASSIGNED_USER_ID_INITIAL_VALUE = '';
export const ASSIGNED_USER_NAME_INITIAL_VALUE = '';
export const ASSIGN_TO_INITIAL_VALUE = '';
export const TEAM_INITIAL_VALUE = {};

export const START_DATE_INITIAL_VALUE = DATE_INITIAL_VALUE;
export const DUE_DATE_INITIAL_VALUE = DATE_INITIAL_VALUE;

export const CHANGE_VERSION = 'changeVersion';

export const LOAD_LIMIT = 20;
export const LOAD_LIMIT_MAX = 999999;

export const FILTER_PANE_WIDTH = '320px';
export const NAV_SETTINGS_PANE_WIDTH = '20%';
export const DETAIL_VIEW_PANE_WIDTH = '44%';
export const SETTINGS_DETAIL_VIEW_PANE_WIDTH = '60%';
export const FILL_PANE_WIDTH = 'fill';
export const FULL_PANE_WIDTH = '100%';

export const DISPLAY_FLEX = 'flex';
export const DISPLAY_NONE = 'none';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIMEZONE = 'UTC';

export const ICONS = {
  ADD: 'plus-sign',
  EDIT: 'edit',
  DELETE: 'trash',
  ARROW_UP: 'arrow-up',
  ARROW_DOWN: 'arrow-down',
  ARROW_RIGHT: 'arrow-right',
  TIMES: 'times',
  TIMES_CIRCLE_SOLID: 'times-circle-solid',
  INFO: 'info',
};

export const ICON_TRANSLATION_KEY_NAME = {
  [ICONS.ADD]: 'add',
  [ICONS.EDIT]: 'edit',
  [ICONS.DELETE]: 'delete',
  [ICONS.ARROW_UP]: 'arrowUp',
  [ICONS.ARROW_DOWN]: 'arrowDown',
};

export const UPDATE_STATUS = {
  ADD: 'add',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const ICON_KEYS = {
  APP: 'app',
};

export const STATUS_CODE_DUPLICATE = 409;

export const APP_NAME = 'task-list'; // TODO:: Rename APP name to tasks!
